export default "__VITE_ASSET__Cd4bxqk9__"